import { render, staticRenderFns } from "./OrderProcess.vue?vue&type=template&id=2e0a831c&scoped=true&"
import script from "./OrderProcess.vue?vue&type=script&lang=js&"
export * from "./OrderProcess.vue?vue&type=script&lang=js&"
import style0 from "./OrderProcess.vue?vue&type=style&index=0&id=2e0a831c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0a831c",
  null
  
)

export default component.exports